import { render, staticRenderFns } from "./knowledgebaseCategoryForm.vue?vue&type=template&id=201833dc&"
import script from "./knowledgebaseCategoryForm.vue?vue&type=script&lang=js&"
export * from "./knowledgebaseCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./knowledgebaseCategoryForm.vue?vue&type=style&index=0&id=201833dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports